import { Icon, TextField } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { useLayout } from "../hooks";
import { isNullOrEmpty } from "../utilities";
import { ACCommandBar } from "./ACCommandBar";
import { NotificationsButton } from "./NotificationsButton";
import { ShowNavButton } from "./ShowNavButton";
import { UserControl } from "./UserControl";
let searchCallback;
export const useSearch = () => {
    const searchValue = useSelector(x => x.layout.search) || '';
    return {
        subscribe: (callback) => {
            searchCallback = callback;
        },
        unsubscribe: () => {
            searchCallback = undefined;
        },
        value: searchValue
    };
};
export const Header = (props) => {
    const layout = useLayout();
    const search = useSearch();
    const showSearchBox = useSelector(x => x.layout.showSearchBox) || false;
    const searchBoxPlaceholder = useSelector(x => x.layout.searchBoxPlaceholder) || 'Search';
    const searchValue = useSelector(x => x.layout.search) || '';
    const headerStyle = {
        zIndex: "1",
        height: "var(--acthemecontainerheader-height)",
        borderColor: "transparent",
        display: "flex",
        flexDirection: "column"
    };
    const searchContainerStyle = {
        height: "44px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: "transparent"
    };
    const useControlStyle = {
        marginRight: "8px",
        display: "flex",
        alignItems: "center",
        width: '60px'
    };
    return React.createElement("header", { style: headerStyle },
        React.createElement("div", { style: searchContainerStyle },
            React.createElement("div", { style: { width: '60px' } },
                React.createElement(ShowNavButton, { onNavItemClick: props.onNavItemClick })),
            React.createElement("div", { style: { "maxWidth": "49%", width: '300px' }, "data-role": "search-container" }, showSearchBox && React.createElement(TextField, { type: "text", placeholder: searchBoxPlaceholder, value: searchValue, onChange: (_, e) => layout.setSearchBoxValue(e), borderless: true, onRenderPrefix: () => {
                    if (isNullOrEmpty(searchValue))
                        return React.createElement(Icon, { iconName: "Search" });
                    return React.createElement(Icon, { iconName: "Clear", style: { cursor: 'pointer' }, onClick: () => layout.resetSearchBox() });
                }, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        searchCallback === null || searchCallback === void 0 ? void 0 : searchCallback(searchValue);
                    }
                    else if (e.key === 'Escape') {
                        layout.resetSearchBox();
                    }
                }, styles: {
                    root: {
                        borderRadius: '5px',
                        boxShadow: "0 1px 2px rgba(0, 0, 0, .14), 0 0 2px rgba(0, 0, 0, .12)",
                        maxWidth: "468px",
                        width: "100%"
                    },
                    fieldGroup: {
                        borderRadius: '5px'
                    },
                    prefix: {
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }
                } })),
            React.createElement("div", { style: useControlStyle },
                React.createElement(NotificationsButton, { onClear: null, onRemove: null }),
                React.createElement(UserControl, { onUserMenuItemClick: props.onUserMenuItemClick }))),
        React.createElement(ACCommandBar, null));
};
